export default {"src":"/_next/static/media/visa.c29b0534.svg","height":2078,"width":3385,"blurWidth":0,"blurHeight":0};